import React, { useEffect, useState } from 'react';
import Axios from '../../utils/axios';
import { MedicineKind } from '../Medicines';
import { DrugUsageList } from './DrugUsage';
import { PrescriptionEditorProps } from './index';

export const PrescriptionAddField: React.FunctionComponent<PrescriptionEditorProps> = (props) => {
	const { prescription, setPrescription } = props;
	const [drugName, setDrugName] = useState('');
	const [drugDose, setDrugDose] = useState<number | null>();
	const [drugFrequency, setDrugFrequency] = useState('');
	const [drugDuration, setDrugDuration] = useState('');
	const [drugKind, setDrugKind] = useState<MedicineKind>('default');

	type DrugAC = {
		name: string;
		kind?: MedicineKind;
		content?: string[];
	};
	const [DrugList, setDrugList] = useState<DrugAC[]>([]);
	const onDrugNameChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
		const drugName = e.target.value;
		let url = `/medicine/?name=${drugName}`;
		if (drugKind !== 'default') {
			url += `&kind=${drugKind}`;
		}

		setDrugName(drugName);
		if (drugName.length > 1) {
			const { data } = await Axios.get(url);

			setDrugList(data.items.slice(0, 20));
		}
	};

	useEffect(() => {
		async function getData() {
			let url = `/medicine/`;
			if (drugKind !== 'default') {
				url += `?kind=${drugKind}`;
			}
			const { data } = await Axios.get(url);

			setDrugList(data.items.slice(0, 20));
		}
		getData();
	}, [drugKind]);

	const addDrug = () => {
		let content;
		if (drugKind === 'construction') {
			content = DrugList.find((drug) => drug.name === drugName)?.content || [];
		}
		setPrescription({
			...prescription,
			medicines: [
				...prescription.medicines,
				{
					drugName,
					drugDose,
					drugFrequency,
					drugDuration,
					kind: drugKind,
					content
				}
			]
		});
		setDrugName('');
		setDrugDose(null);
		setDrugFrequency('');
		setDrugDuration('');
	};

	const ItemClassName = 'flex flex-col';
	const TextFieldClassName = 'mx-2 shadow-md rounded-lg p-1';
	const labelClassName = 'text-center';

	return (
		<div>
			<datalist id="drugs">
				{DrugList.map((item, index) => {
					return <option key={index} value={item.name} />;
				})}
			</datalist>
			<datalist id="drugFrequency">
				{DrugUsageList.map((item, index) => {
					return <option key={index} value={item} />;
				})}
			</datalist>
			<div className="flex flex-row">
				نوع دارو:
				<select
					className={`${TextFieldClassName} px-2`}
					onChange={(e) => setDrugKind(e.target.value as unknown as MedicineKind)}
					value={drugKind}
				>
					<option value="default">پیشفرض</option>
					<option value="construction">ساختنی</option>
					<option value="test">آزمایش</option>
				</select>
			</div>
			<div className="grid grid-cols-4">
				<div className={ItemClassName}>
					<label className={labelClassName}>نام دارو</label>
					<input
						className={TextFieldClassName}
						type="text"
						value={drugName}
						lang="en"
						list="drugs"
						onChange={onDrugNameChange}
					/>
				</div>
				<div className={ItemClassName}>
					<label className={labelClassName}>مقدار</label>
					<input
						className={TextFieldClassName}
						type="number"
						value={drugDose || ''}
						onChange={(e) => setDrugDose(e.target.value as unknown as number)}
					/>
				</div>
				<div className={ItemClassName}>
					<label className={labelClassName}>طریقه مصرف</label>
					<input
						className={TextFieldClassName}
						type="text"
						value={drugFrequency}
						list="drugFrequency"
						onChange={(e) => setDrugFrequency(e.target.value)}
					/>
				</div>
				<div className={ItemClassName}>
					<label className={labelClassName}>مدت درمان</label>
					<input
						className={TextFieldClassName}
						type="text"
						value={drugDuration}
						onChange={(e) => setDrugDuration(e.target.value)}
					/>
				</div>
			</div>
			<div className="flex flex-row-reverse">
				<button
					className="p-2 m-3 text-sm text-white rounded-lg shadow-lg bg-blue-320"
					onClick={addDrug}
				>
					اضافه کردن دارو
				</button>
			</div>
		</div>
	);
};
